import { Box, Icon, IconSize, Text, TextLink } from '@bechtel/gds';
import { Uom } from '@bechtel/ht-types';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { get } from 'lodash';
import { FC, useEffect } from 'react';
import { TextWithEllipsis } from '~/components/atoms/text-with-ellipsis';
import { useGetUomList } from '~/hooks';
import { ContainerStyled, NonCatalogListItemStyled, NonCatalogListItemTextStyled } from './styled';
export interface NonCatalogInfoProps {
  nonCatalogDescription?: string;
  nonCatalogReferenceUrl?: string;
  quantity?: number;
  isViewOption?: boolean;
  onViewDetails?: () => void;
  children?: any;
  iconName?: IconName;
  nonCatalogUomId?: number;
}

export const NonCatalogImage: FC = () => {
  return (
    <NonCatalogListItemStyled ml={{ sm: '400' }}>
      <Icon
        style={{ marginTop: '8px' }}
        iconStyle="regular"
        icon="toolbox"
        size={IconSize.LARGE}
        fillColor="purple.500"
      ></Icon>
      <NonCatalogListItemTextStyled>
        <Text style={{ fontSize: '9px' }} color="white" family="openSansCondensed">
          Non Catalog
        </Text>
      </NonCatalogListItemTextStyled>
    </NonCatalogListItemStyled>
  );
};
export const NonCatalogInfo: FC<NonCatalogInfoProps> = ({
  nonCatalogDescription,
  nonCatalogReferenceUrl,
  quantity,
  isViewOption,
  onViewDetails,
  iconName = 'eye',
  children,
  nonCatalogUomId,
}) => {
  const { getUomList, data: uomListData } = useGetUomList();
  const uomList = get(uomListData, 'searchUoms.items', []);
  const selectedUom =
    uomList?.filter((item: Uom) => {
      return item?.id == nonCatalogUomId;
    })[0] || uomList[0];

  useEffect(() => {
    getUomList();
  }, []);

  return (
    <ContainerStyled>
      <Box gap={{ sm: '500' }}>
        {children}
        <Box flexDirection={{ sm: 'column' }} gap={{ sm: '100' }}>
          <Box alignItems={{ sm: 'center' }} gap={{ sm: '200' }}>
            <Text color="blue.800" weight="600" size="450" family="openSansSemiBold">
              Non-Catalog Item
            </Text>
            {isViewOption && (
              <Icon
                icon={iconName}
                size={IconSize.MEDIUM}
                fillColor="primary.800"
                iconStyle="regular"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  onViewDetails && onViewDetails();
                }}
              ></Icon>
            )}
          </Box>
          <TextWithEllipsis color="grey.600" weight="500" size="300" style={{ width: '170px' }} family="openSans">
            {selectedUom?.abbreviation
              ? `${nonCatalogDescription} (${selectedUom?.abbreviation})`
              : nonCatalogDescription}
          </TextWithEllipsis>
          {nonCatalogReferenceUrl && (
            <Box>
              <TextLink
                style={{
                  fontSize: '12px',
                }}
                href={nonCatalogReferenceUrl}
                target="_blank"
              >
                <TextWithEllipsis
                  size="300"
                  color="blue.500"
                  title={nonCatalogReferenceUrl}
                  style={{ width: '160px', display: 'block' }}
                  family="openSans"
                >
                  {nonCatalogReferenceUrl}
                </TextWithEllipsis>
              </TextLink>
            </Box>
          )}
        </Box>
      </Box>
      {quantity && (
        <Box p={{ sm: '500' }}>
          <Text>{quantity}</Text>
        </Box>
      )}
    </ContainerStyled>
  );
};
